export default {
  phone: 576,
  tablet: 768,
  desktop: 992,
};
